import { Entity } from '@common/types/Entity';
import { theme } from '@prophecy/theme';
import { Stack, StackItem, Text } from '@prophecy/ui-v3';
import React from 'react';
import styled from 'styled-components';

import { Subgraph } from '../config/subgraph';
import { getEntityTableSortConfigVariables } from './Config';
import { EntityTable } from './EntityTable';
import { EntityTableWithCreateButton } from './EntityTableWithCreateButton';

type Props = {
  uid: string;
  entity: Entity.Pipeline;
  projectId: string;
};

const StyledStack = styled(Stack)`
  min-height: 0;
  overflow: auto;
`;

export default function PipelineRelations(props: Props) {
  const { uid, entity } = props;
  const sortConfigVariables = getEntityTableSortConfigVariables(entity);
  return (
    <StyledStack gap={theme.spaces.x40} height='100%' align='space-between'>
      <EntityTableWithCreateButton childEntity={Entity.Job} {...props} />
      <StackItem grow='1' shrink='0'>
        <Stack gap={theme.spaces.x12} height='100%'>
          <StackItem shrink='0'>
            <Text level='sm'>{Entity.Subgraph}s</Text>
          </StackItem>
          <StackItem grow='1'>
            <EntityTable
              schema={{ ...Subgraph('used' + Entity.Subgraph), ownerEntity: entity }}
              sortConfigVariables={sortConfigVariables}
              variables={{ uid }}
            />
          </StackItem>
        </Stack>
      </StackItem>
    </StyledStack>
  );
}
